import React, { useState, useEffect } from 'react';

import { makeStyles, Theme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';

import { IoIosCloseCircleOutline } from 'react-icons/io';

import { useRegisterAdded } from '../../../../../../hooks/registerAdded';
import { useEditProduto } from '../../../../../../hooks/editProduto';
import { useAuth } from '../../../../../../hooks/auth';
import api from '../../../../../../services/api';

import TabPanel from '../../components/TabPanel';

import Detalhes from './tabs/Detalhes';
import Complementos from './tabs/Complementos';
import Disponibilidade from './tabs/Disponibilidade';

import { CloseButton, DrawerContainer, DrawerTitle } from '../../drawer_styles';
import { MenuOptionButton } from '../../../styles';

interface a11yPropsReturnType {
  id: string;
  'aria-controls': string;
}

interface ProdutoProps {
  id: number;
  unidade_medida_id: number;
  descricao: string;
  codigo: string;
  gtin: string;
  tipo: number;
  preco: number;
  observacao: string;
  imagem: string;
  estoque_minimo: number;
  estoque_atual: number;
  grupo_id: number;
}

interface EditProductSimplesProps {
  grupo_produto_id: number;
  produto_id: number;
  tipo_produto: number;
  descricao: string;
  grupo_id: number;
  unidade_medida_id: number;
}

interface QtdTurnos {
  index: number;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  noShadow: {
    boxShadow: 'none',
  },
  tabBorder: {
    borderBottom: '1px solid #e0e0e0',
  },
  noPaddingTop: {
    paddingTop: '0 !important',
  },
}));

function a11yProps(index: number): a11yPropsReturnType {
  return {
    id: `scrollable-auto-tab-${index}`,
    'aria-controls': `scrollable-auto-tabpanel-${index}`,
  };
}

const EditProductSimples: React.FC<EditProductSimplesProps> = ({
  grupo_produto_id,
  produto_id,
  tipo_produto,
  descricao,
  grupo_id,
  unidade_medida_id,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState(0);

  const classes = useStyles();
  const { user } = useAuth();

  const { drawerWasClosed, handleSetDrawerWasClosed } = useRegisterAdded();
  const {
    handleSetEditDrawerOpen,
    editDrawerOpen,
    handleSetProduto,
    handleSetDisponibilidade,
    handleSetSempreDisponivel,
    handleSetInitialQtdTurnos,
    handleSetTurnos,
    cleanData,
  } = useEditProduto();

  useEffect(() => {
    async function loadProdutoData(): Promise<void> {
      const productRequest = await api.post('/produto', { produto_id });
      const estoqueRequest = await api.post(`/estoque/estoque_produto`, {
        produto_id,
        empresa_id: user.empresa_id,
      });

      const productFormatted: ProdutoProps = {} as ProdutoProps;

      productFormatted.id = produto_id;
      productFormatted.unidade_medida_id =
        productRequest.data.unidade_medida_id;
      productFormatted.descricao = productRequest.data.descricao;
      productFormatted.codigo = productRequest.data.codigo;
      productFormatted.gtin = productRequest.data.gtin;
      productFormatted.tipo = productRequest.data.tipo;
      productFormatted.observacao = productRequest.data.observacao;
      productFormatted.imagem = productRequest.data.imagem;
      productFormatted.estoque_minimo = estoqueRequest.data.estoque_minimo;
      productFormatted.estoque_atual = estoqueRequest.data.estoque_atual;
      productFormatted.grupo_id = grupo_id;

      if (tipo_produto === 2) {
        productFormatted.preco = productRequest.data.preco_custo;
      } else {
        const precoRequest = await api.post(`/produto/preco/${produto_id}`);
        productFormatted.preco = precoRequest.data.valor;
      }

      handleSetProduto({ ...productFormatted });
    }

    async function loadDisponibilidade(): Promise<void> {
      const qtdTurnosFinded: QtdTurnos[] = [];
      const response = await api.get(`/produto/disponibilidade/${produto_id}`);

      const { role } = response.data;

      const hasFalseKeys = Object.values(role.dias).includes(false);
      if (role.turnos.length > 0) handleSetTurnos([...role.turnos]);

      for (let i = 0; i < role.turnos.length; i += 1) {
        qtdTurnosFinded.push({ index: i });
      }

      handleSetSempreDisponivel(!hasFalseKeys);
      handleSetInitialQtdTurnos([...qtdTurnosFinded]);
      handleSetDisponibilidade(role);
    }

    if (editDrawerOpen) {
      loadProdutoData();

      if (tipo_produto != 2) {
        loadDisponibilidade();
      }
    }

    if (drawerWasClosed) {
      setValue(0);
      setIsOpen(false);
      handleSetDrawerWasClosed(false);
    }
  }, [
    drawerWasClosed,
    editDrawerOpen,
    handleSetDisponibilidade,
    handleSetProduto,
    grupo_id,
  ]);

  const handleChange = (
    event: React.ChangeEvent<{}>,
    newValue: number,
  ): void => {
    setValue(newValue);
  };

  const toggleDrawer = (open: boolean) => () => {
    if (open) {
      handleSetEditDrawerOpen(true);
    }

    setIsOpen(open);

    if (!open) {
      setValue(0);
      handleSetEditDrawerOpen(false);
      cleanData();
    }

    setIsOpen(open);
  };

  return (
    <>
      <MenuOptionButton type="button" onClick={toggleDrawer(true)}>
        Editar Produto
      </MenuOptionButton>

      <Drawer anchor="right" open={isOpen} onClose={toggleDrawer(false)}>
        <CloseButton onClick={toggleDrawer(false)} type="button">
          <IoIosCloseCircleOutline size={24} />
        </CloseButton>

        <DrawerContainer role="presentation" className={classes.noPaddingTop}>
          <Container maxWidth="lg">
            <Grid item xs={12}>
              <DrawerTitle className="titleDrawer_with_tabs">
                <h1>Edição de Produto</h1>
                <span>
                  Você está editando o produto <b>{descricao}</b>.
                </span>
              </DrawerTitle>
            </Grid>

            <Grid item xs={12}>
              <div className={classes.root}>
                <AppBar
                  position="static"
                  color="transparent"
                  className={classes.noShadow}
                >
                  <Tabs
                    value={value}
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="scrollable"
                    scrollButtons="auto"
                    aria-label="product_tabs"
                    className={classes.tabBorder}
                  >
                    <Tab label="Detalhes" {...a11yProps(0)} />
                    {tipo_produto !== 2 && (
                      <Tab label="Complementos" {...a11yProps(1)} />
                    )}
                    {tipo_produto !== 2 && (
                      <Tab label="Disponibilidade" {...a11yProps(2)} />
                    )}
                  </Tabs>
                </AppBar>

                <TabPanel value={value} index={0}>
                  <Detalhes
                    produto_id={produto_id}
                    tipo_produto={tipo_produto}
                    grupo_id={grupo_id}
                    unidade_medida_id={unidade_medida_id}
                  />
                </TabPanel>

                <TabPanel value={value} index={1}>
                  <Complementos grupo_produto_id={grupo_produto_id} />
                </TabPanel>

                <TabPanel value={value} index={2}>
                  <Disponibilidade produto_id={produto_id} />
                </TabPanel>
              </div>
            </Grid>
          </Container>
        </DrawerContainer>
      </Drawer>
    </>
  );
};

export default EditProductSimples;
